import { render, staticRenderFns } from "./table-info.vue?vue&type=template&id=60eff6c2&scoped=true"
import script from "./table-info.vue?vue&type=script&lang=js"
export * from "./table-info.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60eff6c2",
  null
  
)

export default component.exports